<template>
  <main-layout>
    <transition name="fade">
      <router-view />
    </transition>
  </main-layout>
</template>

<script>
import { mapState } from 'vuex'
import MainLayout from '@/layouts/MainLayout'

export default {
  components: {
    MainLayout
  },

  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated
    })
  },

  created() {
    if (!this.isAuthenticated) {
      this.$router.replace({ name: 'auth.login-page' })
    }
  }
}
</script>
